var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.33,183.4a60.88,60.88,0,1,1-69-51.35A60.82,60.82,0,0,1,180.33,183.4Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,185.49a46.39,46.39,0,1,1-52.57-39.14A46.34,46.34,0,0,1,166,185.49Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.77,184.05c-.27,0-.76-1.94-2-5.34a49.52,49.52,0,0,0-7.34-13.31,48,48,0,0,0-7.29-7.46A46.45,46.45,0,0,0,139,151.68a43.05,43.05,0,0,0-6.05-2.24,42.29,42.29,0,0,0-6.57-1.39,44.12,44.12,0,0,0-6.93-.41,49.57,49.57,0,0,0-7.13.69,50.65,50.65,0,0,0-6.93,1.8A45.66,45.66,0,0,0,99,152.9a43.76,43.76,0,0,0-5.69,3.58,42.44,42.44,0,0,0-4.9,4.18A46.09,46.09,0,0,0,81.05,170a47.71,47.71,0,0,0-4.28,9.51,49.44,49.44,0,0,0-2.31,15c0,3.63.23,5.66,0,5.71s-.9-1.92-1.33-5.64a42.78,42.78,0,0,1,1.28-15.79,46.68,46.68,0,0,1,4.13-10.26,47.32,47.32,0,0,1,7.6-10.23,43.42,43.42,0,0,1,5.19-4.58,44.46,44.46,0,0,1,6.07-3.93,47.72,47.72,0,0,1,6.87-3,50.87,50.87,0,0,1,7.47-2,51.68,51.68,0,0,1,7.69-.73,47.33,47.33,0,0,1,7.48.49,45.9,45.9,0,0,1,7.06,1.6,43.62,43.62,0,0,1,6.45,2.51,47.28,47.28,0,0,1,10.66,7,46.73,46.73,0,0,1,7.41,8.21,42.88,42.88,0,0,1,6.64,14.39C166,181.94,166,184,165.77,184.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.25,218.79l1.28,8-7.12,1.14-1.25-7.76c-7.12.7-14.24-.43-18.65-2.86L106,208a29.24,29.24,0,0,0,14.63,2.84l-1.91-11.9c-8.21-.65-17.47-1.88-19.1-12.07-1.21-7.55,3.24-14.91,14.29-18l-1.27-7.91,7.13-1.14,1.24,7.76a32.84,32.84,0,0,1,15.16,2l-2.16,9.34a29.44,29.44,0,0,0-11.49-2l1.94,12.11c8.2.59,17.32,1.83,18.93,11.88C144.61,208.37,140.22,215.65,129.25,218.79Zm-12.16-30.35-1.62-10.12c-3.64,1.46-4.81,3.77-4.43,6.12S113.79,188,117.09,188.44Zm15,15.21c-.4-2.5-2.68-3.52-5.92-4.1l1.58,9.84C131.19,208,132.46,205.93,132.09,203.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.39,128.67a44.24,44.24,0,1,1-60.71-14.81A44.18,44.18,0,0,1,401.39,128.67Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.39,134.12a33.72,33.72,0,1,1-46.27-11.28A33.69,33.69,0,0,1,392.39,134.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.84,133.22c-.17.12-1.06-1.07-2.87-3a35.63,35.63,0,0,0-8.68-6.82,34.48,34.48,0,0,0-7-2.93,34,34,0,0,0-8.56-1.32,32.22,32.22,0,0,0-4.68.22,31.37,31.37,0,0,0-4.79.93,31.8,31.8,0,0,0-4.76,1.69,33.45,33.45,0,0,0-8.7,5.66,32.36,32.36,0,0,0-3.48,3.66,32.34,32.34,0,0,0-4.89,8.19,33.34,33.34,0,0,0-2.27,8.36,34.73,34.73,0,0,0-.17,7.57,35.81,35.81,0,0,0,2.71,10.7c1,2.43,1.76,3.73,1.59,3.84s-1.15-1-2.49-3.39a31.2,31.2,0,0,1-3.62-10.93,33.83,33.83,0,0,1-.15-8,34.58,34.58,0,0,1,4.36-13.54,33.74,33.74,0,0,1,3-4.35,33.13,33.13,0,0,1,3.73-4,34,34,0,0,1,9.38-6.1,33.47,33.47,0,0,1,5.15-1.79,32.93,32.93,0,0,1,5.17-.94,31.67,31.67,0,0,1,5-.14,33.64,33.64,0,0,1,16.39,5,31.12,31.12,0,0,1,8.52,7.74C391.36,131.76,392,133.14,391.84,133.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.25,166.82l3.11,5-4.44,2.78-3-4.84c-4.57,2.48-9.65,3.75-13.3,3.37l-.95-7a21.14,21.14,0,0,0,10.6-2.25l-4.65-7.42c-5.68,1.89-12.22,3.7-16.2-2.66-2.95-4.71-2.06-10.9,4.46-16.09l-3.09-4.94,4.45-2.78,3,4.85A23.66,23.66,0,0,1,368,131.93l1.2,6.86a21.57,21.57,0,0,0-8.25,1.94l4.73,7.56c5.66-1.94,12.11-3.68,16,2.58C384.57,155.49,383.7,161.61,377.25,166.82ZM360.5,150l-3.95-6.31c-2,2-2.15,3.88-1.23,5.35S358.16,150.56,360.5,150Zm14.35,5.92c-1-1.55-2.79-1.59-5.12-1.06l3.84,6.13C375.49,159.07,375.74,157.31,374.85,155.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.82,87.71a22.78,22.78,0,1,1,7.07-31.39A22.75,22.75,0,0,1,341.82,87.71Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.93,83.13a17.36,17.36,0,1,1,5.39-23.93A17.34,17.34,0,0,1,338.93,83.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.38,82.84c-.05-.09.55-.56,1.53-1.51a18.42,18.42,0,0,0,3.43-4.53,17.72,17.72,0,0,0,1.44-3.63,17.15,17.15,0,0,0,.6-4.41,15.15,15.15,0,0,0-.15-2.41,16.59,16.59,0,0,0-.52-2.46,17,17,0,0,0-.92-2.43,19.4,19.4,0,0,0-1.32-2.34A18.88,18.88,0,0,0,341.8,57a17.47,17.47,0,0,0-1.91-1.76,16.21,16.21,0,0,0-2.09-1.4,15.43,15.43,0,0,0-2.17-1,18.09,18.09,0,0,0-4.33-1.09,17.54,17.54,0,0,0-3.9,0,18.33,18.33,0,0,0-5.49,1.49,10.11,10.11,0,0,1-2,.85,5.18,5.18,0,0,1,1.73-1.31,16.18,16.18,0,0,1,5.59-2,17.47,17.47,0,0,1,4.14-.14,17.7,17.7,0,0,1,4.65,1,16.58,16.58,0,0,1,2.36,1.08,16.86,16.86,0,0,1,2.26,1.48,18.48,18.48,0,0,1,2.09,1.88,21,21,0,0,1,1.8,2.26A19.06,19.06,0,0,1,346,60.9a17.47,17.47,0,0,1,1,2.64,16.58,16.58,0,0,1,.53,2.65,17.53,17.53,0,0,1,.12,2.59,17.53,17.53,0,0,1-2.45,8.49,16,16,0,0,1-3.91,4.45A5.17,5.17,0,0,1,339.38,82.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322,75.63l-2.54,1.65L318,75l2.46-1.6a12.75,12.75,0,0,1-1.85-6.81l3.57-.56a11,11,0,0,0,1.25,5.44L327.16,69c-1-2.91-2-6.26,1.22-8.37,2.4-1.56,5.59-1.16,8.33,2.15l2.51-1.63,1.47,2.26L338.23,65a12.32,12.32,0,0,1,1.61,5.49l-3.52.68A11.17,11.17,0,0,0,335.24,67l-3.85,2.51c1.05,2.89,2,6.2-1.18,8.27C327.85,79.29,324.7,78.9,322,75.63Zm8.52-8.78,3.22-2.09c-1.05-1-2-1.07-2.77-.58S330.15,65.65,330.48,66.85Zm-2.92,7.45c.8-.52.8-1.45.51-2.65l-3.13,2C325.93,74.65,326.84,74.77,327.56,74.3Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M472.2,450.44c0,.15-99.49.26-222.19.26s-222.21-.11-222.21-.26,99.47-.26,222.21-.26S472.2,450.3,472.2,450.44Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.26,419.74c1.13-4.37-1.74-8.77-5-11.94s-7.06-6-8.73-10.21c-2.71-6.8.93-15.6-3.69-21.27-2.72-3.34-7.6-4.46-10-8-1.27-1.87-1.68-4.17-2.18-6.37A64.58,64.58,0,0,0,41.6,331.82a56.18,56.18,0,0,0,6.32,29c1.87,3.56,4.17,7,4.79,11,1,6.46-2.6,13.12-1,19.46,1.81,7.26,10,12.12,10.35,19.59.33,6.32-5.18,11.86-4.77,18.17a17.21,17.21,0,0,0,2.81,7.49C65,444.69,72.15,450.28,83,450.1l13.32.46Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.26,419.74c1.13-4.37-1.74-8.77-5-11.94s-7.06-6-8.73-10.21c-2.71-6.8.93-15.6-3.69-21.27-2.72-3.34-7.6-4.46-10-8-1.27-1.87-1.68-4.17-2.18-6.37A64.58,64.58,0,0,0,41.6,331.82a56.18,56.18,0,0,0,6.32,29c1.87,3.56,4.17,7,4.79,11,1,6.46-2.6,13.12-1,19.46,1.81,7.26,10,12.12,10.35,19.59.33,6.32-5.18,11.86-4.77,18.17a17.21,17.21,0,0,0,2.81,7.49C65,444.69,72.15,450.28,83,450.1l13.32.46Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M99,450.47a10.6,10.6,0,0,0,3.67-.07,23.27,23.27,0,0,0,4.32-1.09,18.46,18.46,0,0,0,5.35-2.93,7.47,7.47,0,0,0,2.2-2.93,13.59,13.59,0,0,0,.62-4,40.54,40.54,0,0,1,.32-4.31,11.81,11.81,0,0,1,1.62-4.28c1.57-2.76,4.18-5.37,5-9.12s.26-7.67-.36-11.67-1.22-8.35.31-12.51,4.35-7.93,5.81-12.62.78-9.85,1.08-14.88a19.83,19.83,0,0,1,1.74-7.39c1.08-2.36,2.57-4.58,3.74-7.07,2.36-5,2.78-10.7,3.43-16.27q.47-4.22,1-8.51a42.34,42.34,0,0,1,1.48-8.52,74.38,74.38,0,0,1,3.19-8.24,28.17,28.17,0,0,0,1.54-4.31,42.41,42.41,0,0,0,.43-4.58,53.76,53.76,0,0,0-.35-9.22c-.36-3.07-.92-6.12-1.25-9.2l-.06-.53-.07-.61-.54.27a20.61,20.61,0,0,0-7.17,6.05,32.7,32.7,0,0,0-4.41,8.12c-2.22,5.72-3,11.72-4.14,17.44S125,328.86,122,333.62c-1.45,2.37-3.22,4.53-4.77,6.85a18.89,18.89,0,0,0-3.3,7.59c-.79,5.63,2.31,10.58,1.67,15.57a17.27,17.27,0,0,1-2.43,6.91c-1.21,2.13-2.63,4.1-4,6.09a39.13,39.13,0,0,0-3.58,6.14,19.36,19.36,0,0,0-1.63,6.68c-.33,4.49.31,8.75,0,12.77a29.45,29.45,0,0,1-3.28,10.95c-1.62,3.27-3.41,6.24-4.91,9.11-.75,1.44-1.45,2.84-2,4.24a21.52,21.52,0,0,0-1.17,4.22,26.66,26.66,0,0,0-.09,7.6A19.07,19.07,0,0,0,96.33,448a9.74,9.74,0,0,0,1.07,1.17,5.75,5.75,0,0,0,.88.74c.49.37.76.53.76.53a15.78,15.78,0,0,1-2.58-2.55,19.26,19.26,0,0,1-3.62-9.62,26.89,26.89,0,0,1,.17-7.5,21.6,21.6,0,0,1,1.18-4.11c.57-1.37,1.27-2.77,2-4.19,1.52-2.84,3.33-5.79,5-9.09a29.64,29.64,0,0,0,3.4-11.14c.35-4.11-.26-8.38.08-12.77a18.65,18.65,0,0,1,1.6-6.45,37.75,37.75,0,0,1,3.54-6c1.34-2,2.78-3.95,4-6.13a18,18,0,0,0,2.55-7.19c.64-5.32-2.44-10.3-1.64-15.53a18,18,0,0,1,3.19-7.26c1.52-2.28,3.3-4.44,4.8-6.87,3-4.9,4.49-10.63,5.6-16.38s1.93-11.69,4.12-17.3a31.7,31.7,0,0,1,4.29-7.9,19.65,19.65,0,0,1,6.87-5.8l-.62-.34.06.54c.34,3.11.89,6.17,1.25,9.2a53.18,53.18,0,0,1,.35,9.08,40,40,0,0,1-.41,4.45,26.45,26.45,0,0,1-1.49,4.15,76.51,76.51,0,0,0-3.21,8.33,42.14,42.14,0,0,0-1.5,8.66q-.48,4.31-.94,8.52c-.64,5.59-1.06,11.19-3.33,16-1.13,2.41-2.62,4.64-3.73,7.08a20.55,20.55,0,0,0-1.79,7.66c-.29,5.14.38,10.17-1,14.72s-4.28,8.31-5.75,12.61-.92,8.84-.29,12.82,1.29,7.91.43,11.46-3.3,6.16-4.9,9a12.16,12.16,0,0,0-1.65,4.45,37.29,37.29,0,0,0-.28,4.36,13.54,13.54,0,0,1-.57,3.87,7.06,7.06,0,0,1-2.07,2.8,18.55,18.55,0,0,1-5.21,2.95,23.44,23.44,0,0,1-4.27,1.15,16.92,16.92,0,0,1-2.71.27C99.36,450.46,99,450.47,99,450.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.12,293.57a2,2,0,0,0-.13.41c-.08.32-.17.71-.29,1.2-.26,1.05-.58,2.63-1.08,4.61s-1.73,4.2-2.76,6.95a98.13,98.13,0,0,0-3.17,9.45c-1,3.55-1.92,7.5-2.86,11.72s-1.94,8.74-4.26,13c-1.09,2.16-2.32,4.35-3.3,6.75a31,31,0,0,0-1.91,7.64,153.15,153.15,0,0,1-2.88,16.11c-2.67,10.92-5.21,21.31-7.53,30.78l-6.31,25.1c-1.75,7.1-3.18,12.87-4.18,16.93-.46,2-.83,3.5-1.1,4.62-.1.49-.19.89-.26,1.21a1.43,1.43,0,0,0-.06.41,2,2,0,0,0,.15-.39l.34-1.19c.31-1.11.72-2.64,1.25-4.57,1.07-4.06,2.59-9.8,4.45-16.88l6.49-25.05c2.34-9.47,4.9-19.86,7.6-30.78a154.76,154.76,0,0,0,2.87-16.18A30.87,30.87,0,0,1,124,348c.94-2.33,2.15-4.51,3.24-6.7,2.35-4.34,3.32-9,4.26-13.2s1.77-8.17,2.74-11.72,2-6.7,3-9.43,2.15-5,2.64-7.05.72-3.59.93-4.66c.08-.49.15-.89.21-1.21A2,2,0,0,0,141.12,293.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.39,450.56c8.7-5.17,11.2-20.47,7.57-29.92s-10-18.08-11-28.15c-.76-7.74,1.78-15.69,0-23.26C95.54,359,85.57,351.11,85.69,340.61c.06-5.89,3.41-11.43,3.15-17.32-.33-7.21-5.87-12.94-9.3-19.3-5.26-9.73-5.6-21.24-7.4-32.15s-6-22.6-15.62-28c-1.43,9.26-3.87,15.61-3.1,28.16.27,4.51,5.51,13.13,6.22,23,.43,5.91.72,11.82,1.08,17.73.35,5.75.72,11.6,2.79,17,1.58,4.13,4.11,7.87,5.29,12.13,2.2,8-.7,16.68,1.08,24.79,1.51,6.87,6.27,12.79,7.24,19.76,1.37,9.79-5,20-1.73,29.3,1.61,4.64,5.43,8.36,6.51,13.14.84,3.72-.08,7.65.68,11.38,1.23,6,12.69,10.68,18.81,10.3",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.91,253.07a3,3,0,0,0,0,.53c0,.39.12.89.2,1.52.2,1.34.42,3.3.87,5.84s1.81,5.43,2.86,8.9,2.21,7.45,3.19,11.91,1.82,9.41,2.69,14.72,1.83,11.11,4.46,16.65c1.22,2.78,2.59,5.56,3.62,8.53a38,38,0,0,1,1.83,9.4,189.55,189.55,0,0,0,2.56,20.26c2.66,13.73,5.2,26.8,7.51,38.71s4.63,22.53,6.47,31.52,3.38,16.17,4.44,21.24c.53,2.46.95,4.39,1.25,5.77.14.62.26,1.11.35,1.49a2.46,2.46,0,0,0,.14.5,1.73,1.73,0,0,0-.06-.52c-.07-.38-.15-.88-.26-1.51-.26-1.38-.63-3.32-1.09-5.8-1-5.08-2.42-12.34-4.17-21.29s-3.93-19.69-6.3-31.56l-7.44-38.69A190.41,190.41,0,0,1,79.51,331a38.75,38.75,0,0,0-1.9-9.59c-1.06-3-2.44-5.82-3.67-8.58-2.62-5.45-3.54-11.15-4.48-16.45s-1.77-10.26-2.8-14.73-2.17-8.47-3.33-11.93-2.46-6.33-3-8.82-.78-4.48-1-5.8c-.12-.62-.21-1.12-.28-1.51A2,2,0,0,0,58.91,253.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438,391a11.13,11.13,0,0,1,5.77,6.53,19.75,19.75,0,0,1,.77,8.85c-.65,5.75-3.92,11.54-7.43,16.13-4.84-4.22-6-11.58-6.28-15.35-.52-6,2.15-17.05,7.17-16.16",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.72,432a9.51,9.51,0,0,1,3.07-9,12.62,12.62,0,0,1,9.3-2.91,5.33,5.33,0,0,1,4.08,1.83,4.05,4.05,0,0,1,.07,4.12,8.21,8.21,0,0,1-3.05,3c-4.19,2.63-8.73,4.41-13.47,3",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52,449.58a7,7,0,0,1,.17-1.18c.15-.83.35-1.9.59-3.19A33.14,33.14,0,0,1,440.57,435a20.33,20.33,0,0,1,7.31-7.77,13.31,13.31,0,0,1,3-1.32,7.78,7.78,0,0,1,.86-.22c.2,0,.31-.06.31,0a18.88,18.88,0,0,0-11.1,9.55,35.66,35.66,0,0,0-3.36,10c-.3,1.34-.54,2.42-.72,3.16A5.89,5.89,0,0,1,436.52,449.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.7,399.59a3.65,3.65,0,0,1,.06.52c0,.38.05.87.09,1.48.07,1.28.14,3.14.22,5.45.14,4.6.26,11,.23,18s-.2,13.39-.39,18c-.09,2.3-.19,4.16-.27,5.45,0,.6-.07,1.09-.1,1.48a2.37,2.37,0,0,1-.06.51,3,3,0,0,1,0-.52c0-.38,0-.87,0-1.48,0-1.34.08-3.19.13-5.45.12-4.6.24-11,.27-18s0-13.38-.11-18c0-2.26-.06-4.11-.09-5.45v-1.48A3,3,0,0,1,436.7,399.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.35,435.46a22.2,22.2,0,0,0-12.13-16.27c-1.61-.78-3.73-1.28-5.05-.08s-1,3.37-.39,5a19,19,0,0,0,17.46,11.78",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,424.64a5.36,5.36,0,0,1,1,.44,11.5,11.5,0,0,1,1.16.62,17.21,17.21,0,0,1,1.48.93,20.14,20.14,0,0,1,1.69,1.27,23.69,23.69,0,0,1,1.8,1.63,24.78,24.78,0,0,1,3.41,4.39,24.34,24.34,0,0,1,2.25,5.09,22.29,22.29,0,0,1,.57,2.36,20.19,20.19,0,0,1,.29,2.1,15.77,15.77,0,0,1,.08,1.74,10.43,10.43,0,0,1,0,1.31,5.76,5.76,0,0,1-.12,1.12c-.1,0,.07-1.6-.21-4.14a20,20,0,0,0-.34-2.06,20.78,20.78,0,0,0-.6-2.31,24.72,24.72,0,0,0-2.24-5,25.31,25.31,0,0,0-3.33-4.34,23.54,23.54,0,0,0-1.75-1.63,18.88,18.88,0,0,0-1.63-1.3C424.42,425.38,423,424.72,423,424.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M367.16,231.21s-46.69-33.09-52.6-36.34c-5.63-3.1-23.5-5.35-25.1-5.74l-32-7-48.88,1.46-14,8.43L159.1,208.4a42.08,42.08,0,0,0-21.33,22.26l-22.4,54.71L171,301.81l1.73,57.71-13.11,90.92H322.3l-8.19-174.25,16.94,3.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,278.57s-.59.43-1.72,1.09a14.25,14.25,0,0,1-5.2,1.9,19.25,19.25,0,0,1-8.11-1.18,57.83,57.83,0,0,1-9.24-4c-3.17-1.65-6.14-3.32-8.92-4.66a49.83,49.83,0,0,0-7.62-3.05,30.14,30.14,0,0,0-5.42-1.1c-.65-.07-1.15-.1-1.5-.11l-.52,0a14.09,14.09,0,0,1,2,.07,27.71,27.71,0,0,1,5.45,1,48.21,48.21,0,0,1,7.66,3c2.8,1.34,5.77,3,8.94,4.66a59.76,59.76,0,0,0,9.2,4,19.33,19.33,0,0,0,8,1.21,14.3,14.3,0,0,0,5.17-1.82c.57-.32,1-.58,1.3-.76S172,278.57,172,278.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.62,251.61h-.37l-1.06-.05c-.92-.05-2.25-.15-3.89-.31a102,102,0,0,1-25-5.76c-1.55-.57-2.79-1.06-3.64-1.42l-1-.42-.34-.16.36.12,1,.38c.86.34,2.11.81,3.66,1.36a109.41,109.41,0,0,0,25,5.75c1.63.18,3,.31,3.87.38l1.06.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.59,194.87s-.42.68-1.3,1.82A25.77,25.77,0,0,1,199,201a37.85,37.85,0,0,1-7.75,4.64,78.58,78.58,0,0,1-10.41,3.8c-3.77,1.12-7.37,2.11-10.6,3.17a61.24,61.24,0,0,0-8.38,3.35,36.16,36.16,0,0,0-5.22,3.11c-.6.4-1,.77-1.32,1s-.47.34-.47.34.59-.54,1.74-1.41a35.91,35.91,0,0,1,5.2-3.18,61.15,61.15,0,0,1,8.39-3.39c3.23-1.08,6.84-2.07,10.6-3.19a79.76,79.76,0,0,0,10.39-3.77,39,39,0,0,0,7.74-4.58,26.65,26.65,0,0,0,4.37-4.22c.47-.54.76-1,1-1.31S204.59,194.87,204.59,194.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,202.32s-.15-.07-.43-.23-.66-.4-1.2-.67a30.4,30.4,0,0,0-4.64-2,52,52,0,0,0-7.28-1.87c-2.78-.53-5.87-.94-9.11-1.4L265.4,193.8l-5-.74-1.37-.21-.47-.09.48.05,1.37.17,5,.67L282,195.94c3.24.45,6.33.87,9.12,1.41a49.55,49.55,0,0,1,7.28,1.92,28.65,28.65,0,0,1,4.64,2.08C304.1,201.94,304.64,202.32,304.64,202.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,213.36s-.37.18-1.08.49-1.77.76-3.14,1.31c-2.75,1.09-6.76,2.6-11.84,4.08a130.62,130.62,0,0,1-18.14,4c-6.93,1.06-14.66,1.06-22.71.79s-15.76-.61-22.74-.17a70.2,70.2,0,0,0-18.19,3.32,45.36,45.36,0,0,0-11.2,5.49c-1.19.86-2.12,1.54-2.7,2.06s-.92.75-.92.75.3-.28.89-.78,1.49-1.22,2.69-2.1a44.49,44.49,0,0,1,11.19-5.56,70,70,0,0,1,18.23-3.37c7-.45,14.69-.11,22.75.15s15.77.28,22.69-.77a131.12,131.12,0,0,0,18.12-4c5.07-1.46,9.09-2.95,11.85-4,1.38-.54,2.44-1,3.15-1.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.32,223.14a.6.6,0,0,1-.18.09l-.53.19c-.46.17-1.13.39-2,.63a26.13,26.13,0,0,1-6.73,1,23,23,0,0,1-6.73-1c-.84-.25-1.51-.48-2-.66l-.52-.21-.18-.09.2,0,.53.17c.46.16,1.13.37,2,.6a24.51,24.51,0,0,0,6.69.9,28.44,28.44,0,0,0,6.7-1c.83-.23,1.51-.42,2-.57l.53-.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.77,251.44s-4.8,1-12.63,2.18c-3.92.59-8.6,1.17-13.81,1.69s-11,.91-17,1.14-11.8.21-17,.1-10-.39-13.9-.69c-7.9-.6-12.75-1.26-12.75-1.26l.88.07,2.54.25c2.2.23,5.39.51,9.34.79s8.66.51,13.89.64,11,.1,17-.11,11.77-.64,17-1.12,9.89-1.08,13.81-1.65,7.08-1.07,9.26-1.46l2.51-.44Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.93,248.6l-.36,0-1,0c-.91,0-2.22,0-3.84,0-3.24,0-7.72-.13-12.64-.55s-9.37-1.09-12.55-1.67c-1.6-.28-2.88-.54-3.77-.73l-1-.22-.35-.09.36,0,1,.18,3.77.67c3.19.54,7.62,1.18,12.54,1.6s9.4.56,12.63.61l3.84,0h1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,289.82s-.29.06-.82.13l-2.36.33c-1,.15-2.28.32-3.75.42s-3.13.3-5,.33-3.87.17-6,.13c-1.09,0-2.21,0-3.37,0l-3.57-.12c-4.89-.19-10.25-.56-15.87-1s-11-1-15.85-1.29-9.27-.51-13-.45h-2.63l-2.35.12c-1.46.06-2.73.13-3.75.26l-2.37.23-.83.07s.29-.05.83-.11l2.36-.28c1-.14,2.29-.21,3.76-.29l2.35-.13,2.63,0c3.7-.07,8.11.11,13,.41s10.23.8,15.85,1.27,11,.86,15.86,1.07l3.56.13c1.16,0,2.28,0,3.37,0,2.17,0,4.19-.05,6-.1s3.51-.22,5-.31,2.72-.24,3.75-.38l2.36-.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.85,278.08l-.44.07-1.28.13c-1.1.12-2.71.25-4.69.39-4,.27-9.47.46-15.54.31s-11.56-.65-15.51-1.13c-2-.24-3.57-.46-4.67-.63l-1.26-.2-.44-.09.44.05,1.27.16c1.1.15,2.7.35,4.68.57,3.95.44,9.42.9,15.49,1.06s11.56,0,15.53-.25c2-.11,3.59-.23,4.7-.32l1.27-.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.56,314.42l-1.46-.08c-1,0-2.37-.2-4.19-.25-3.64-.19-8.91-.23-15.42.09s-14.22,1.09-22.76,2.22S252.83,319,243,320.24A241.72,241.72,0,0,1,215,322.37a128.25,128.25,0,0,1-22.81-1.65,91.68,91.68,0,0,1-14.95-3.78c-.87-.27-1.62-.56-2.27-.82l-1.66-.66c-.89-.35-1.35-.55-1.35-.55l1.37.51,1.66.64c.65.26,1.41.54,2.28.81a93,93,0,0,0,14.95,3.7A130.12,130.12,0,0,0,215,322.18,243.92,243.92,0,0,0,243,320c9.85-1.27,19.21-2.73,27.76-3.83S287,314.33,293.49,314a151.16,151.16,0,0,1,15.42,0C312.55,314.21,314.56,314.42,314.56,314.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.57,351.76s-4.81.82-12.65,1.66c-3.91.42-8.59.8-13.79,1.1s-10.94.44-16.95.41-11.74-.31-16.94-.65-9.87-.82-13.78-1.3c-7.83-1-12.62-1.84-12.62-1.84l.88.11,2.51.37c1.08.17,2.42.36,4,.55s3.32.46,5.27.66c3.92.46,8.59.9,13.78,1.26s10.92.57,16.93.63,11.74-.13,16.94-.39,9.87-.65,13.79-1.06c2-.18,3.73-.41,5.28-.58s2.89-.35,4-.5l2.51-.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,344.6s-.19.07-.54.17l-1.53.47c-1.34.4-3.28.95-5.69,1.6-4.81,1.29-11.52,2.89-19,4.26s-14.33,2.26-19.29,2.76c-2.48.25-4.49.42-5.88.52l-1.6.11-.56,0,.55-.07,1.6-.15c1.39-.12,3.4-.32,5.87-.59,5-.54,11.79-1.44,19.27-2.81s14.18-2.95,19-4.21c2.41-.62,4.35-1.15,5.69-1.53l1.55-.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.42,393.45a70.56,70.56,0,0,1-7.78.77c-2.41.13-5.29.14-8.49,0a88,88,0,0,1-20.47-3.43c-3.07-.91-5.79-1.86-8-2.77a75.33,75.33,0,0,1-7.11-3.26l.5.22,1.41.65c.61.29,1.36.64,2.25,1s1.87.82,3,1.24c2.24.9,5,1.83,8,2.73a100.18,100.18,0,0,0,10.12,2.3A102.64,102.64,0,0,0,205.16,394c3.19.14,6.06.15,8.47,0,1.21,0,2.3-.13,3.26-.19s1.77-.15,2.45-.22l1.54-.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.62,390.9l-1,.18-2.86.46c-2.48.39-6.08.94-10.53,1.57-8.9,1.27-21.23,2.85-34.88,4.21s-26.06,2.22-35,2.72c-4.49.25-8.13.43-10.64.53l-2.89.11-1,0,1-.06,2.89-.15,10.63-.59c9-.54,21.36-1.44,35-2.79s26-2.91,34.88-4.14l10.54-1.51,2.86-.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.86,427.73s-2.18.46-6.17,1.11-9.77,1.46-17,2.06a223,223,0,0,1-25.35.62c-9.55-.31-20-1.38-30.93-2.72s-21.35-2.69-30.86-3.43a199.61,199.61,0,0,0-25.33-.57,127.65,127.65,0,0,0-17,1.94c-2,.38-3.52.7-4.55.95l-1.58.36s.54-.15,1.57-.4,2.56-.59,4.54-1a122.85,122.85,0,0,1,17-2,195.13,195.13,0,0,1,25.34.51c9.53.74,19.94,2.09,30.87,3.43s21.38,2.41,30.92,2.72a223.85,223.85,0,0,0,25.33-.57c7.19-.58,13-1.37,17-2,2-.32,3.54-.57,4.59-.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.2,222.26s-.29.79-.94,2.17A40.68,40.68,0,0,1,348,230a72.46,72.46,0,0,1-6,7.45c-2.42,2.68-5.2,5.5-8,8.56a73,73,0,0,0-7.3,9.14,38.13,38.13,0,0,0-4.29,8.51A26.46,26.46,0,0,0,321,270c-.1.75-.07,1.35-.1,1.75s0,.61,0,.61a20.15,20.15,0,0,1,.06-2.37,25.3,25.3,0,0,1,1.33-6.32,37.82,37.82,0,0,1,4.27-8.56,72.7,72.7,0,0,1,7.31-9.19c2.82-3.05,5.61-5.87,8-8.54a74.21,74.21,0,0,0,6-7.41,41.14,41.14,0,0,0,3.31-5.52c.36-.68.57-1.23.75-1.59S352.2,222.26,352.2,222.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.14,239.49l.34-.25,1-.68c.88-.57,2.11-1.45,3.59-2.59s3.19-2.56,5-4.24a76,76,0,0,0,5.55-5.79,78.37,78.37,0,0,0,4.85-6.4c1.36-2.06,2.51-4,3.39-5.61s1.56-3,2-4l.51-1.09.19-.38A55.27,55.27,0,0,1,330,214c-.87,1.66-2,3.58-3.37,5.64a71.14,71.14,0,0,1-4.84,6.43,72.72,72.72,0,0,1-5.58,5.8c-1.83,1.67-3.54,3.1-5,4.22A54.19,54.19,0,0,1,306.14,239.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.67,286.25a.86.86,0,0,1,.24-.11l.72-.28c.65-.22,1.56-.62,2.73-1.16a35.89,35.89,0,0,0,8.85-6.3,69.64,69.64,0,0,0,10.13-12.57,177.11,177.11,0,0,0,9.88-17.2,300.7,300.7,0,0,0,14-33.22c1.57-4.34,2.79-7.88,3.65-10.31l1-2.81c.11-.3.2-.53.27-.73s.1-.24.1-.24a1,1,0,0,1-.05.26c-.06.2-.14.44-.23.74-.21.69-.51,1.64-.9,2.84-.79,2.46-2,6-3.5,10.37a277.47,277.47,0,0,1-13.91,33.33,171.7,171.7,0,0,1-9.93,17.23,69,69,0,0,1-10.28,12.57,34.41,34.41,0,0,1-9,6.21,25.53,25.53,0,0,1-2.77,1.09l-.74.23A.88.88,0,0,1,234.67,286.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,307.41a3.28,3.28,0,0,1,.54-.42l1.62-1.11c1.39-1,3.4-2.41,5.82-4.26,4.85-3.69,11.22-9.2,18.06-15.49,3.44-3.14,6.73-6.11,9.57-8.95a75.49,75.49,0,0,0,7.06-8,44.13,44.13,0,0,0,3.86-6.07c.42-.74.68-1.35.88-1.75a4.56,4.56,0,0,1,.33-.6,2.86,2.86,0,0,1-.23.65c-.18.41-.41,1-.81,1.79a38.82,38.82,0,0,1-3.75,6.19,69.83,69.83,0,0,1-7,8.12c-2.84,2.88-6.12,5.86-9.56,9a234.92,234.92,0,0,1-18.19,15.4c-2.45,1.83-4.49,3.21-5.93,4.14-.71.47-1.28.8-1.66,1A5.25,5.25,0,0,1,233,307.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,414.32l.12-.23c.11-.16.24-.37.4-.63.35-.56.89-1.36,1.61-2.38,1.45-2,3.68-4.87,6.62-8.21,5.93-6.66,14.23-15.73,23.38-25.78l23.51-25.65,7.17-7.74,2-2.09.52-.53c.12-.12.18-.18.19-.17s-.05.07-.15.2l-.49.57L269,343.83c-1.7,1.88-4.1,4.56-7.05,7.84l-23.41,25.76L215,403.1c-3,3.31-5.24,6.11-6.73,8.1-.75,1-1.31,1.78-1.69,2.31l-.43.61A.81.81,0,0,1,206,414.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.36,234.59a10.13,10.13,0,0,1-.37-1.52c-.11-.49-.23-1.1-.32-1.81s-.24-1.52-.28-2.42-.15-1.89-.14-3,0-2.2.08-3.4a43.8,43.8,0,0,1,3.74-15c.51-1.08,1-2.11,1.52-3s1-1.78,1.51-2.54,1-1.43,1.38-2a17,17,0,0,1,1.13-1.45,10.3,10.3,0,0,1,1-1.17,9,9,0,0,1-.89,1.29c-.3.4-.67.89-1.05,1.49s-.87,1.25-1.31,2-1,1.61-1.45,2.55-1,2-1.46,3a45.54,45.54,0,0,0-3.7,14.88c-.06,1.18-.15,2.3-.13,3.35s0,2,.08,2.93.14,1.7.21,2.41.15,1.32.23,1.82A8.29,8.29,0,0,1,299.36,234.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.91,270.47c-.12,0-1.92-3.92-4-8.88s-3.68-9-3.56-9.08a96.61,96.61,0,0,1,4,8.88A92.79,92.79,0,0,1,313.91,270.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,238.76c-.08.05-.86-1.38-2.33-3.55a50,50,0,0,0-14.58-14.15c-2.21-1.4-3.66-2.14-3.62-2.22a5.25,5.25,0,0,1,1.06.44c.67.31,1.61.81,2.75,1.48a44.54,44.54,0,0,1,8.18,6.27,45,45,0,0,1,6.51,8c.7,1.12,1.23,2.05,1.56,2.71A5.51,5.51,0,0,1,171,238.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.25,215.12a2.91,2.91,0,0,1,0-1,8.26,8.26,0,0,1,2.29-5l.06-.06,0,.07a1.89,1.89,0,0,1,.16.44s-.11-.13-.25-.39h.09a10,10,0,0,0-1.57,2.55A12.56,12.56,0,0,0,210.25,215.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.49,222a3,3,0,0,1-.21-1,9.47,9.47,0,0,1,.06-2.46,9.57,9.57,0,0,1,.69-2.36,3.25,3.25,0,0,1,.5-.88,15.85,15.85,0,0,0-1,3.28A16.07,16.07,0,0,0,223.49,222Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.92,220.84a16.2,16.2,0,0,0-.38-2.77,14.6,14.6,0,0,0-1.09-2.59,2.7,2.7,0,0,1,.5.67,7.51,7.51,0,0,1,.79,1.86,8.13,8.13,0,0,1,.27,2A2.43,2.43,0,0,1,237.92,220.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,215.31a16.91,16.91,0,0,0-1.5-2.54,17.4,17.4,0,0,0-2.1-2.07,2.86,2.86,0,0,1,.75.45,8.35,8.35,0,0,1,1.51,1.49,8.45,8.45,0,0,1,1.08,1.83A2.75,2.75,0,0,1,250.54,215.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,206.74A6.14,6.14,0,0,0,257.5,204a5.91,5.91,0,0,0-2.95-1.31s.1,0,.27,0a3.88,3.88,0,0,1,.71.09,5,5,0,0,1,2.11,1.08,4.88,4.88,0,0,1,1.37,1.93,3,3,0,0,1,.2.69A1,1,0,0,1,259.23,206.74Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.88,190.91a6.46,6.46,0,0,0-2.63-1.26,6.29,6.29,0,0,0-2.91.24,4.59,4.59,0,0,1,5.54,1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.57,204.45a2.55,2.55,0,0,1,.21-.86,5.86,5.86,0,0,1,2.83-3.08,2.53,2.53,0,0,1,.84-.28,7.05,7.05,0,0,0-3.88,4.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.41,193.91a2.81,2.81,0,0,1,.5-.8,7.12,7.12,0,0,1,1.67-1.57,7.53,7.53,0,0,1,2.08-1,2.85,2.85,0,0,1,.93-.16,9.3,9.3,0,0,0-5.18,3.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.55,255.37s0-.06-.06,0a1.46,1.46,0,0,0-.09.32c-.05.31-.1.76-.16,1.35-.12,1.17-.25,2.87-.39,5-.29,4.21-.62,10-.93,16.47s-.55,12.26-.69,16.48c-.07,2-.12,3.74-.16,5,0,.54,0,1-.06,1.36a2.48,2.48,0,0,1,0,.47,1.34,1.34,0,0,1-.05-.47c0-.37,0-.82,0-1.36,0-1.18,0-2.89,0-5,0-4.22.22-10.06.54-16.5s.7-12.26,1.08-16.47c.19-2.11.38-3.81.56-5,.09-.58.18-1,.26-1.34a1.12,1.12,0,0,1,.14-.34C173.54,255.25,173.57,255.39,173.55,255.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.73,53.38c-8.34-2.55-17,4.92-25.6,3.24-5.2-1-9.12-5.17-13.75-7.75-6.91-3.86-16.69-4.49-23.75-.9S209,55.38,208.05,63.25c-6.43-3.69-17.15,4.4-20.8,12.21s-2.74,15.87-.67,24.24a113.72,113.72,0,0,0,18.82,40c.78,1.06,2,2.23,3.21,1.67a2.91,2.91,0,0,0,1.24-2.31c1.23-7.65.26-15.46-.41-23.18s-1-15.68,1.45-23,8.2-14.06,15.8-15.56c5.62-1.11,11.45.71,16.44,3.52s9.38,6.55,14.13,9.74,10.09,5.88,15.81,6.12,11.86-2.44,14.29-7.62-.29-12.54-5.89-13.73a11.26,11.26,0,0,0,2.26-22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,187.53,257.19,171s21.82-4.18,21.33-26.13c-.24-10.59-2.52-32.38-4.8-52.07A40.9,40.9,0,0,0,231.65,56.6l-2.12.07c-22.77,2.14-33.69,22.68-30.92,45.39l5.25,88.4a27.11,27.11,0,0,0,28.5,25.47h0A27.12,27.12,0,0,0,258,187.53Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.22,171s-13.83,1.61-28.89-7.13c0,0,7.32,15.56,29.14,12.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.33,107.65a3.14,3.14,0,0,1-2.91,3.26,3,3,0,0,1-3.33-2.71,3.13,3.13,0,0,1,2.9-3.27A3,3,0,0,1,266.33,107.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.38,103.66c-.38.42-2.81-1.25-6.18-1.12s-5.78,1.9-6.16,1.5c-.19-.18.18-.93,1.23-1.75a8.6,8.6,0,0,1,4.91-1.71,8.23,8.23,0,0,1,4.94,1.41C269.19,102.74,269.56,103.47,269.38,103.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.21,110a3.14,3.14,0,0,1-2.91,3.27,3,3,0,0,1-3.33-2.71,3.14,3.14,0,0,1,2.91-3.27A3,3,0,0,1,233.21,110Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.26,105.45c-.37.42-2.81-1.25-6.18-1.12s-5.78,1.9-6.16,1.5c-.19-.18.18-.93,1.23-1.75a8.63,8.63,0,0,1,4.92-1.71,8.21,8.21,0,0,1,4.93,1.41C236.07,104.54,236.45,105.26,236.26,105.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.37,130c0-.2,2.06-.63,5.44-1.18.86-.12,1.67-.32,1.8-.92a4.44,4.44,0,0,0-.67-2.53c-.88-2.05-1.8-4.21-2.77-6.46-3.87-9.21-6.7-16.8-6.32-17s3.8,7.19,7.66,16.4q1.41,3.4,2.67,6.51a5,5,0,0,1,.57,3.36,2.17,2.17,0,0,1-1.37,1.31,5.73,5.73,0,0,1-1.46.25C251.51,130.13,249.39,130.22,249.37,130Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.53,132.71c.55-.06.69,3.6,3.91,6.09s7.1,1.95,7.15,2.46c.06.23-.84.74-2.49.84a9.07,9.07,0,0,1-6-1.84,7.94,7.94,0,0,1-3-5.12C238.91,133.61,239.28,132.69,239.53,132.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236,88.17c-.3.92-3.68.61-7.62,1.22s-7.1,1.81-7.65,1c-.25-.39.27-1.27,1.53-2.2a13.37,13.37,0,0,1,11.64-1.7C235.36,87,236.12,87.73,236,88.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.8,94c-.57.78-2.92.07-5.71.13s-5.14.7-5.72-.09c-.25-.38.1-1.16,1.11-1.92a7.8,7.8,0,0,1,4.59-1.41A7.89,7.89,0,0,1,266.68,92C267.69,92.79,268.05,93.56,267.8,94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,118.24c-.38-.15-15.23-3.93-14.23,11s15.84,10.88,15.84,10.45S201,118.24,201,118.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.62,134.37c-.07,0-.25.2-.68.43A2.56,2.56,0,0,1,195,135c-1.63-.48-3.13-2.9-3.38-5.6a8.61,8.61,0,0,1,.48-3.78,3,3,0,0,1,1.83-2.14,1.33,1.33,0,0,1,1.59.61c.23.41.15.71.23.73s.31-.27.14-.88a1.69,1.69,0,0,0-.65-.9,2,2,0,0,0-1.47-.28,3.66,3.66,0,0,0-2.57,2.5,8.91,8.91,0,0,0-.62,4.24c.3,3,2,5.73,4.24,6.21a2.8,2.8,0,0,0,2.36-.55C197.62,134.74,197.67,134.4,197.62,134.37Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.2,88a31.71,31.71,0,0,1-28.37-5.35c-5.5-4.34-9.84-10.7-16.6-12.53a17.83,17.83,0,0,0-13.56,2.35,34.38,34.38,0,0,0-10,9.85c4.63,11,2.22,23.55-.26,35.22a6,6,0,0,1-1.63,3.53c-1.72,1.42-4.42.45-6-1.11-2.57-2.51-3.66-6.14-4.41-9.64A61.61,61.61,0,0,1,196.64,86a42,42,0,0,1,10.8-21.6A39.8,39.8,0,0,1,235,52.86,48.92,48.92,0,0,1,263.68,62c3.88,2.72,7.48,6,9.58,10.29",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.21,58.45a3.13,3.13,0,0,1-.09,1.31,6.06,6.06,0,0,1-2,3.16A9.54,9.54,0,0,1,282.59,65a16.19,16.19,0,0,1-3.72-.1A7.91,7.91,0,0,1,275,63.25a5.27,5.27,0,0,1-2-4.17A4.66,4.66,0,0,1,276,55.14a5.94,5.94,0,0,1,2.69-.44,4.93,4.93,0,0,1,2.61,1.07,6.83,6.83,0,0,1,2.42,5.16,7.93,7.93,0,0,1-2.17,5.59,12,12,0,0,1-5.33,3.27c-4.12,1.29-8.72.67-12.86-.94A56.29,56.29,0,0,1,252,62.56a71.28,71.28,0,0,0-10.29-6.07,22.2,22.2,0,0,0-10.39-2.15A21.24,21.24,0,0,0,222.47,57a26.67,26.67,0,0,0-9.64,9.4A34.24,34.24,0,0,0,211,69.61a9.4,9.4,0,0,1-.59,1.16,1.2,1.2,0,0,1,.1-.32c.07-.2.18-.51.35-.9a26.74,26.74,0,0,1,1.69-3.34,26.25,26.25,0,0,1,9.62-9.71,21.62,21.62,0,0,1,9.11-2.77A22.73,22.73,0,0,1,242,55.86,71.5,71.5,0,0,1,252.44,62a56.67,56.67,0,0,0,11.19,6.21c4.05,1.56,8.47,2.16,12.39.94A11.42,11.42,0,0,0,281,66,7.17,7.17,0,0,0,283,61a6.16,6.16,0,0,0-2.14-4.67,4.51,4.51,0,0,0-4.66-.57,4.09,4.09,0,0,0-2.71,3.4,4.8,4.8,0,0,0,1.79,3.74,7.55,7.55,0,0,0,3.62,1.57,16,16,0,0,0,3.62.15A9.37,9.37,0,0,0,288,62.7a6.2,6.2,0,0,0,2-3A10,10,0,0,0,290.21,58.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,88.47a25.57,25.57,0,0,0,4.62,1,13.17,13.17,0,0,0,5-.7,21.88,21.88,0,0,0,5.53-2.91,17.61,17.61,0,0,0,6.37-9.17,37.57,37.57,0,0,0,.83-4.68,4.12,4.12,0,0,1,.12,1.3,14.33,14.33,0,0,1-.45,3.52,17.09,17.09,0,0,1-6.44,9.64,21.23,21.23,0,0,1-5.75,3,12.7,12.7,0,0,1-5.27.57,12.14,12.14,0,0,1-3.44-.92A3.68,3.68,0,0,1,185,88.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.06,99.3c0-.14,1.78.19,4.61-.07a20.61,20.61,0,0,0,17.09-12.18c1.17-2.59,1.43-4.36,1.57-4.33a3.93,3.93,0,0,1-.12,1.25,16.68,16.68,0,0,1-1,3.28A19.87,19.87,0,0,1,190.7,99.76a17.44,17.44,0,0,1-3.42-.16A4,4,0,0,1,186.06,99.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,120.18a.38.38,0,0,1-.45-.31.37.37,0,0,1,.26-.48.41.41,0,0,1,.19.79Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232,118.49a.48.48,0,0,1-.21-.91.44.44,0,0,1,.47.37A.43.43,0,0,1,232,118.49Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.29,118.23c-.21,0-.41-.21-.47-.54s.07-.63.27-.66.41.21.47.54S236.49,118.2,236.29,118.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.87,124.11c-.2,0-.38-.09-.38-.22s.16-.25.36-.25.38.09.38.22S229.08,124.1,228.87,124.11Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.73,122.53a.4.4,0,0,1-.42-.37.4.4,0,0,1,.32-.47.41.41,0,0,1,.42.38A.4.4,0,0,1,234.73,122.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.35,117.78a.39.39,0,0,1-.46-.32.38.38,0,0,1,.26-.49.42.42,0,0,1,.2.81Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.72,117.23a.48.48,0,0,1-.12-.93c.2,0,.39.16.43.41A.44.44,0,0,1,269.72,117.23Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.47,118a.33.33,0,1,1,.29-.4A.36.36,0,0,1,261.47,118Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.88,122.31a.42.42,0,0,1-.52-.23.4.4,0,0,1,.15-.55.44.44,0,0,1,.37.78Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.6,121.42a.34.34,0,0,1-.29-.39.35.35,0,0,1,.44-.21.34.34,0,0,1,.29.38A.35.35,0,0,1,268.6,121.42Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.18,370.64l-.24-22.23s-14.83-20.55-9-42.84c0,0,9.67-6.8,35.6-2.82,0,0,32.55-31.71,76.18-23.64s47.69,46.08,48.11,56.43.32,30.45-14.7,50.1l-1,19.5s-3.58,7.34-13.93,6.84-9.77-2-9.77-2-13,10.49-13.56,13.23-2.6,13.13-2.6,13.13-4.51,6.13-14.24,6.85a21.08,21.08,0,0,1-11.13-2.28,11,11,0,0,1-5.51-6.47,22.8,22.8,0,0,0-12.23-14.09l-6.72-1.76s-2.71,2.47-12.14,3.48-9.47-2.33-9.47-2.33-14.67,3.39-25.69-11C250.44,397.36,245.71,376.89,261.18,370.64Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.62,371.92a5.94,5.94,0,0,1,.49-.68c.33-.44.82-1.08,1.43-1.92,1.23-1.67,2.95-4.14,4.85-7.33a84.36,84.36,0,0,0,5.74-11.68c.91-2.28,1.76-4.71,2.51-7.26s1.38-5.31.72-8a11.38,11.38,0,0,0-4.8-6.3,34.57,34.57,0,0,0-6.78-3.53,45.68,45.68,0,0,0-12.6-3,46.39,46.39,0,0,0-8.76,0c-1,.09-1.83.19-2.38.27a4.29,4.29,0,0,1-.83.09,5.28,5.28,0,0,1,.82-.19c.53-.11,1.33-.25,2.37-.37a42.27,42.27,0,0,1,8.81-.17A44.29,44.29,0,0,1,356,324.76a34.44,34.44,0,0,1,6.89,3.55,11.81,11.81,0,0,1,5,6.6c.7,2.87,0,5.73-.73,8.28s-1.63,5-2.56,7.3a80.79,80.79,0,0,1-5.86,11.69,78.73,78.73,0,0,1-5,7.26c-.64.83-1.16,1.45-1.51,1.86A4.44,4.44,0,0,1,351.62,371.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.62,303.72a1.73,1.73,0,0,1,.15.51,5.46,5.46,0,0,1,.07,1.55,8.73,8.73,0,0,1-2.5,5.05c-1.63,1.8-4.11,3.27-6.53,5.25a54.94,54.94,0,0,0-7.31,7.09,57.89,57.89,0,0,0-9.62,15.74c-.9,2.2-1.49,4-1.89,5.3-.17.59-.32,1.08-.44,1.47a2.34,2.34,0,0,1-.18.5,1.92,1.92,0,0,1,.08-.53c.1-.4.21-.89.35-1.5a48.59,48.59,0,0,1,1.74-5.37,54.91,54.91,0,0,1,9.57-15.95,53.3,53.3,0,0,1,7.4-7.12c2.47-2,4.95-3.41,6.57-5.13a8.8,8.8,0,0,0,2.56-4.82A9.48,9.48,0,0,0,290.62,303.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.06,306.44l13.27,3.39S340.76,288,362.1,282.47l-8-1.89A92.34,92.34,0,0,0,308.06,306.44Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M357.77,281.42a89.63,89.63,0,0,0-45.59,26l-4.12-1s18.82-20.65,46.05-25.86Z",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M357.77,281.42a89.63,89.63,0,0,0-45.59,26l-4.12-1s18.82-20.65,46.05-25.86Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M254.77,375.17c7.35-10.52,25.79-7.3,34.2,2.16s12.14,22.48,6.67,33.7c-2.34,4.79-6.82,9-12.15,8.9a25,25,0,0,0,5.7-22.25c-1.71-7.85-6.66-14.78-12.92-19.82-3.17-2.56-6.74-5.37-10.8-5.77s-7.31-.52-10.7,3.08",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.77,375.17c7.35-10.52,25.79-7.3,34.2,2.16s12.14,22.48,6.67,33.7c-2.34,4.79-6.82,9-12.15,8.9a25,25,0,0,0,5.7-22.25c-1.71-7.85-6.66-14.78-12.92-19.82-3.17-2.56-6.74-5.37-10.8-5.77s-7.31-.52-10.7,3.08"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M352.36,371.3c-.14,2.23,1.9,4.2,4.11,4.46a7.06,7.06,0,0,0,5.89-2.58,16.42,16.42,0,0,0,3-5.92c2.3-7.21,3.49-18,2.28-25.43-3.18,9.67-8.86,21.73-15.45,29.49"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M359.33,338.05c-1.43-4.23-5.81-6.7-10-8.16A48.13,48.13,0,0,0,336,327.27a10.5,10.5,0,0,0-4.25.41,4.22,4.22,0,0,0-2.79,3,2.81,2.81,0,0,0,1.42,2.9,79.24,79.24,0,0,1,15.87,28.81,2.7,2.7,0,0,0,4.64,1c3.4-3.88,5.36-9.11,7.12-14.07C359.27,345.68,360.57,341.7,359.33,338.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M263.72,340A42.37,42.37,0,0,1,257,316.26c0-1.77.26-3.69,1.49-4.95,1.49-1.53,3.91-1.56,6-1.42A114.52,114.52,0,0,1,282,312.35c.45.1,1,.25,1.14.68a1.71,1.71,0,0,1-.39,2c-8.95,5.49-15.3,15.59-18.68,25.47"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M252.57,306.36a9,9,0,0,1-.07,1.51c-.08,1-.17,2.37-.23,4.1a62.27,62.27,0,0,0,2.6,20.7c.68,2.19,1.39,4.12,2.07,5.72s1.27,2.87,1.7,3.73a7.33,7.33,0,0,1,.62,1.38,8.87,8.87,0,0,1-.8-1.28c-.49-.84-1.13-2.1-1.85-3.69a52.24,52.24,0,0,1-2.2-5.71,61.8,61.8,0,0,1-1.78-7.29A59.83,59.83,0,0,1,251.9,312c.11-1.73.25-3.14.4-4.1A8.14,8.14,0,0,1,252.57,306.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.33,279.86a2.47,2.47,0,0,1-.52.19l-1.5.44c-.66.18-1.46.4-2.38.7s-2,.59-3.11,1c-2.31.77-5,1.8-7.95,3.06s-6.12,2.82-9.35,4.62-6.19,3.73-8.82,5.56-4.9,3.63-6.75,5.2c-.95.75-1.76,1.5-2.49,2.13s-1.34,1.19-1.83,1.66l-1.16,1.05c-.27.24-.42.36-.43.34a2.47,2.47,0,0,1,.36-.41l1.09-1.13c.47-.49,1.06-1.07,1.78-1.72s1.5-1.42,2.44-2.2c1.83-1.61,4.1-3.42,6.71-5.31a103.91,103.91,0,0,1,8.85-5.62,102.36,102.36,0,0,1,9.41-4.61c3-1.24,5.7-2.24,8-3,1.16-.39,2.22-.66,3.15-.93s1.74-.47,2.41-.62l1.52-.34A1.89,1.89,0,0,1,353.33,279.86Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,332.7c-.08.09-1.59-1.45-4.49-3.3a36.82,36.82,0,0,0-5.34-2.79,40.6,40.6,0,0,0-7-2.21,43.16,43.16,0,0,0-13.34-.81c-3.42.35-5.49.92-5.52.81a9.82,9.82,0,0,1,1.45-.42,29.9,29.9,0,0,1,4-.75,40.14,40.14,0,0,1,13.5.66,39.44,39.44,0,0,1,7.1,2.28,33.38,33.38,0,0,1,5.35,2.93l1,.69.87.69a12.35,12.35,0,0,1,1.34,1.15A9.47,9.47,0,0,1,365,332.7Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.55,418.31a1.7,1.7,0,0,1-.48-.13,13.92,13.92,0,0,1-1.33-.48,30.84,30.84,0,0,1-4.67-2.32,34.31,34.31,0,0,1-16.68-28.57,30.5,30.5,0,0,1,.27-5.2c.07-.61.18-1.08.23-1.4a3.19,3.19,0,0,1,.12-.48,14.52,14.52,0,0,1-.15,1.9,36.42,36.42,0,0,0-.11,5.17,35.11,35.11,0,0,0,16.51,28.27,38.63,38.63,0,0,0,4.56,2.45C274.93,418,275.56,418.27,275.55,418.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M278.17,395.21a4.22,4.22,0,0,0-4.48,1.15,5.48,5.48,0,0,0-1.27,4.57,7,7,0,0,0,1.91,4.17,5.92,5.92,0,0,0,3.3,1.61,4.24,4.24,0,0,0,3.71-2.37,6.56,6.56,0,0,0-3.17-9.13"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M276.62,395a6.66,6.66,0,0,0,3.55,10.72,3.82,3.82,0,0,1-3.36.89,6.9,6.9,0,0,1-4.7-7.12,5.28,5.28,0,0,1,1.45-3.38,4.53,4.53,0,0,1,3.06-1.11",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M276.62,395a6.66,6.66,0,0,0,3.55,10.72,3.82,3.82,0,0,1-3.36.89,6.9,6.9,0,0,1-4.7-7.12,5.28,5.28,0,0,1,1.45-3.38,4.53,4.53,0,0,1,3.06-1.11"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M263.43,389.52a4.1,4.1,0,0,0-4.32,1.12,5.29,5.29,0,0,0-1.23,4.41,6.94,6.94,0,0,0,1.85,4,5.75,5.75,0,0,0,3.19,1.55,4.07,4.07,0,0,0,3.57-2.28,6.35,6.35,0,0,0-3.06-8.82"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M261.94,389.34a6.41,6.41,0,0,0,3.43,10.34,3.72,3.72,0,0,1-3.25.87,6.67,6.67,0,0,1-4.53-6.88,5.06,5.06,0,0,1,1.39-3.25,4.39,4.39,0,0,1,3-1.08",
    style: {
      fill: "#E4A13E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.94,389.34a6.41,6.41,0,0,0,3.43,10.34,3.72,3.72,0,0,1-3.25.87,6.67,6.67,0,0,1-4.53-6.88,5.06,5.06,0,0,1,1.39-3.25,4.39,4.39,0,0,1,3-1.08"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M303.19,361.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.37,362s.1,0,.14-.07l.07,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.93,365.12a5.68,5.68,0,0,0-2.59-3,6.71,6.71,0,0,0-3.06-.71h-.09a3.88,3.88,0,0,0-1.68.5,7.27,7.27,0,0,0-4,5.85,8,8,0,0,0,4.6,7.6,4.84,4.84,0,0,0,3.07.46,4.78,4.78,0,0,0,2.57-1.81A9,9,0,0,0,308.93,365.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272,351.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,352.27a.75.75,0,0,1,.13-.06l.06,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,355a4.89,4.89,0,0,0-2.25-2.64,5.78,5.78,0,0,0-2.64-.62H272a3.35,3.35,0,0,0-1.45.44,6.28,6.28,0,0,0-3.47,5.07,6.91,6.91,0,0,0,4,6.57,3.61,3.61,0,0,0,4.88-1.16A7.83,7.83,0,0,0,277,355Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279,371.71a2.49,2.49,0,0,1,.62.12,17.55,17.55,0,0,1,1.74.54,23,23,0,0,1,5.88,3.19,26.38,26.38,0,0,1,6.73,7.3,30.81,30.81,0,0,1,4.18,11.4,36.28,36.28,0,0,1-.14,12.16,18.31,18.31,0,0,1-4.15,9,12.17,12.17,0,0,1-5.62,3.59,6.76,6.76,0,0,1-2.43.33,15.06,15.06,0,0,0,2.37-.52,12.39,12.39,0,0,0,5.41-3.65,18.2,18.2,0,0,0,3.95-8.82,36.12,36.12,0,0,0,.09-12,30.77,30.77,0,0,0-4.07-11.23,26.63,26.63,0,0,0-6.54-7.26,25.45,25.45,0,0,0-5.73-3.3C279.86,372,279,371.76,279,371.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.45,359.88c-.05,0-.31-.18-.58-.65a4.44,4.44,0,0,1-.51-2,4.33,4.33,0,0,1,.5-2c.27-.47.52-.69.58-.65a11.51,11.51,0,0,0-.56,2.68A12,12,0,0,0,269.45,359.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.6,370.93c-.06,0-.31-.23-.53-.76a4.14,4.14,0,0,1-.21-2.21,4,4,0,0,1,.92-2c.38-.44.7-.6.74-.55a9.18,9.18,0,0,0-1.15,2.65A8.56,8.56,0,0,0,299.6,370.93Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.57,423.77c-.05.08-1.26-.76-3.38-1.82a63.64,63.64,0,0,0-8.59-3.4c-3.45-1.12-6.59-2.08-8.84-2.88-1.12-.39-2-.73-2.64-1a4.38,4.38,0,0,1-.93-.45,36.19,36.19,0,0,1,3.69,1.1c2.26.71,5.42,1.61,8.88,2.74a50.52,50.52,0,0,1,8.6,3.57c.53.27,1,.56,1.39.81a9.7,9.7,0,0,1,1,.68A4,4,0,0,1,318.57,423.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.52,391.56a10.53,10.53,0,0,1-.92,1.41c-.6.89-1.55,2.14-2.76,3.64a103.73,103.73,0,0,1-10.46,10.86c-4.37,4-8.44,7.39-11.32,9.95l-3.4,3a10.22,10.22,0,0,1-1.28,1.08,9.89,9.89,0,0,1,1.14-1.22c.76-.77,1.89-1.85,3.3-3.17,2.82-2.63,6.85-6.11,11.2-10.06a121.88,121.88,0,0,0,10.53-10.71c1.25-1.46,2.24-2.67,2.89-3.52A10.73,10.73,0,0,1,389.52,391.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M372.52,410.08c5.38.44,11.49-1.21,15.31-5a13.81,13.81,0,0,0,2.85-15.1c-3.14,4.48-6.68,9.24-11,12.9-2.72,2.31-4.53,5.11-7.16,7.23"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M353.36,284.31c7,10.3,21.35,13.56,28.29,23.88,2.69,4,4,8.72,5.3,13.36l16,57.73c.66-12.51-2.35-24.89-5.35-37.06q-4.42-18-8.87-36a22.36,22.36,0,0,0-2.88-7.59c-1.58-2.27-3.93-3.86-6.22-5.4-8.22-5.52-16.68-11.14-26.32-13.34"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.28,315.49c.44,1.4-1.48,3.31-4.47,5.68-1.51,1.18-3.27,2.53-5.21,4s-4,3.08-6.17,4.82-4.13,3.47-6,5-3.5,3.06-5,4.29c-2.93,2.45-5.18,3.94-6.47,3.22s-1.2-3.56.51-7.54a31.18,31.18,0,0,1,3.87-6.48,40.18,40.18,0,0,1,14.24-11.59,31.81,31.81,0,0,1,7.13-2.47C301,313.59,303.86,314.15,304.28,315.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M277.53,394.41a10.7,10.7,0,0,1-2.27.55,11.33,11.33,0,0,1-2.27.53,3.75,3.75,0,0,1,2.15-1A3.9,3.9,0,0,1,277.53,394.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.35,388.9a18.14,18.14,0,0,1-2.11.37c-1.13.25-2,.72-2.06.59s.7-.82,1.94-1.1A2.89,2.89,0,0,1,262.35,388.9Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.67,435.4c-.14.07-1.47-2.17-3.32-4.8s-3.5-4.64-3.39-4.74a20.75,20.75,0,0,1,3.82,4.44A21.21,21.21,0,0,1,329.67,435.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.1,330.45c.14.09-1.83,3-3.54,6.9s-2.53,7.31-2.69,7.27a7.84,7.84,0,0,1,.4-2.25,33.24,33.24,0,0,1,1.81-5.23,33.64,33.64,0,0,1,2.63-4.87A9,9,0,0,1,270.1,330.45Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.58,311.09a20.38,20.38,0,0,1-5.61-1.37,21.3,21.3,0,0,1-5.25-2.42c.07-.14,2.43.88,5.42,1.92S318.62,310.94,318.58,311.09Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.58,294.88a16,16,0,0,1-9.65,6.21,55.93,55.93,0,0,0,5.13-2.63A56.8,56.8,0,0,0,396.58,294.88Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.87,288.19c-5.38-12.4-59.12-56.42-59.12-56.42l-30.3,39.34c.44-.59,49.43,29.25,49.43,29.25l14.45,65.88h0L402.82,378s-6.5,5.67-6.23,11.65c.17,4-9,12.61-9,12.61-2.18-1.81-3.58-2.32-4.68-2.11l-9.75,9.13,2.32,2.12a13.46,13.46,0,0,0,9.49,3.51l16.67-.51a9.13,9.13,0,0,0,6.29-2.77c5.13-5.27,15.95-17.06,16.16-22.74.13-3.18.15-6.21.14-8.65C424.18,380.21,431.24,300.59,425.87,288.19Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.91,393.54a3.43,3.43,0,0,1-.93.6c-.61.34-1.55.74-2.64,1.34a11.62,11.62,0,0,0-3.27,2.81,18.81,18.81,0,0,1-4,3.72,15.63,15.63,0,0,1-9.44,2.6,5.12,5.12,0,0,1-1.72-.3,1.2,1.2,0,0,1-.8-1.06.9.9,0,0,1,.35-.77c.17-.1.28-.08.28-.07s-.09,0-.22.15a.78.78,0,0,0-.21.68,1,1,0,0,0,.71.81,4.88,4.88,0,0,0,1.62.2,16,16,0,0,0,9.15-2.66,18.89,18.89,0,0,0,3.91-3.6,11.52,11.52,0,0,1,3.45-2.83c1.14-.57,2.09-.91,2.73-1.2A6.43,6.43,0,0,1,409.91,393.54Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.29,402.22c.07.13-1.31.94-2.79,2.2s-2.52,2.47-2.64,2.38a7.72,7.72,0,0,1,2.32-2.76A7.42,7.42,0,0,1,402.29,402.22Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,374.93c0,.15-1.47.24-3.08,1s-2.63,1.83-2.74,1.72a6.23,6.23,0,0,1,5.82-2.74Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.6,407.36c0,.09-1.07-.43-2.87-.85a16.18,16.18,0,0,0-9.06.38,7.57,7.57,0,0,1-1,.3,1.43,1.43,0,0,1-1.07-.23L382,405a16.61,16.61,0,0,1-2.35-1.88,18.54,18.54,0,0,1,2.57,1.58l2.69,1.83c.43.33,1,.08,1.63-.15a17.18,17.18,0,0,1,2-.56,15.6,15.6,0,0,1,7.29.3,12.83,12.83,0,0,1,2.07.79C398.37,407.18,398.62,407.33,398.6,407.36Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.53,254.56c-6.41-1.83-9.25-2.62-9.25-2.62V249l2.55,0c2.56,0,6.24-3.19,6.24-3.19l5.47-8.37.7-5.37c-.58-6.62-8.56-4-8.56-4-.38-2.31-10.6-4.63-18.28-6.06a17.66,17.66,0,0,0-14.63,3.86l-7.37,6.22L220.32,251.4l-57,48.15-37.47-11.06S113.93,324.94,112,338c-3.73,25.09,30.76,41.81,46,28.9,11.82-10,80.76-84.28,92.18-96.59h.09c7-.89,18.88-8,18.88-8l6.09.72s16.18,3.09,18.1-.08C294.78,260.5,291.94,256.39,285.53,254.56Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.34,247.28s.16.23.35.7a12.74,12.74,0,0,1,.66,2.05,18.39,18.39,0,0,1,.26,7.07,18.08,18.08,0,0,1-2.44,6.64,12.46,12.46,0,0,1-1.26,1.74c-.33.39-.53.59-.56.56s.64-.92,1.5-2.48A20,20,0,0,0,253,250.1C252.65,248.35,252.25,247.31,252.34,247.28Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.47,226.86a4.1,4.1,0,0,1,.62-.11c.42-.06,1-.14,1.81-.21a28.11,28.11,0,0,1,6.72.07,16.14,16.14,0,0,1,4.47,1.34,11.9,11.9,0,0,1,4.25,3.26,8.69,8.69,0,0,1,2.05,5.55,6.91,6.91,0,0,1-.79,3.09,11,11,0,0,1-2,2.6,30.73,30.73,0,0,1-4.89,3.85,16.36,16.36,0,0,1-2.63,1.44,3.59,3.59,0,0,1-1.5.25,1.89,1.89,0,0,1-1.38-.7,2.17,2.17,0,0,1-.43-1.43,4.43,4.43,0,0,1,.25-1.37,10,10,0,0,1,1.17-2.31,9.72,9.72,0,0,1,3.44-3.09l.06.35-6.82-1.3-1.85-.38a2.81,2.81,0,0,1-.64-.17,3.62,3.62,0,0,1,.66.06l1.86.29,6.85,1.13.53.09-.47.26a9.51,9.51,0,0,0-3.26,3,9.17,9.17,0,0,0-1.09,2.22,2.55,2.55,0,0,0,.12,2.35,2,2,0,0,0,2.33.28,15,15,0,0,0,2.52-1.4,29.93,29.93,0,0,0,4.8-3.79,7.74,7.74,0,0,0,2.61-5.33,8.25,8.25,0,0,0-1.91-5.24,11.65,11.65,0,0,0-4.07-3.17,15.81,15.81,0,0,0-4.34-1.36,30.4,30.4,0,0,0-6.64-.24l-1.82.11A2.33,2.33,0,0,1,256.47,226.86Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.76,228.38a4.45,4.45,0,0,1,.17,1.08,25.68,25.68,0,0,1,.12,3,19.07,19.07,0,0,1-2.49,9.46c-2,3.35-5.13,5.51-7.72,5.85a3.26,3.26,0,0,1-2.82-1,2.17,2.17,0,0,1-.42-.72.55.55,0,0,1-.05-.28,4.55,4.55,0,0,0,.62.86,3.11,3.11,0,0,0,2.63.74c2.38-.39,5.4-2.52,7.31-5.74a20,20,0,0,0,2.57-9.21C282.81,229.93,282.67,228.38,282.76,228.38Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.61,256.94c-.06-.07.46-.52,1.08-1.42a8.45,8.45,0,0,0,1.44-3.89,8.31,8.31,0,0,0-.67-4.1c-.43-1-.85-1.54-.78-1.59a3.59,3.59,0,0,1,1.11,1.43,7.59,7.59,0,0,1-.81,8.37A3.73,3.73,0,0,1,268.61,256.94Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.89,238a3.24,3.24,0,0,1,.32,2.19,5.78,5.78,0,0,1-.7,2.34,10.8,10.8,0,0,1-1.7,2.42,12.44,12.44,0,0,1-4.49,2.87,8.58,8.58,0,0,1-2.09.7,9.76,9.76,0,0,1,1.94-1,14.32,14.32,0,0,0,4.26-2.9,11.48,11.48,0,0,0,1.66-2.3,5.93,5.93,0,0,0,.76-2.15A10.51,10.51,0,0,0,258.89,238Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.41,240.94l-28.13,15.33S288.33,260,302,274.45a82.82,82.82,0,0,1,17.12,27.23l28-18.64S332.05,248.9,301.41,240.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.24,255.7l22.71-13,.07,0,.07,0a48.87,48.87,0,0,1,11.49,4.73A64.15,64.15,0,0,1,324,255.85a88.54,88.54,0,0,1,10.58,11.59,97.76,97.76,0,0,1,9.13,14.15l.11.21-.2.13-1.47,1-21.62,14.45-.26.17-.11-.28a79.53,79.53,0,0,0-12.46-20.9,71.34,71.34,0,0,0-14.21-12.92,63.76,63.76,0,0,0-11-6.12c-1.36-.58-2.42-1-3.15-1.23l-.82-.28-.28-.1.29.06.84.24c.74.23,1.81.6,3.18,1.15a61.91,61.91,0,0,1,11.16,6,70.7,70.7,0,0,1,14.35,12.91,79.53,79.53,0,0,1,12.6,21l-.37-.11,21.61-14.47,1.47-1-.09.33a98.22,98.22,0,0,0-9.06-14.07,88.29,88.29,0,0,0-10.5-11.54,64.44,64.44,0,0,0-11.35-8.4A48.81,48.81,0,0,0,301,243.06l.14,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.29,264.94c-.74,4.33-6.22,6.95-12.25,5.85s-10.34-5.5-9.6-9.83,6.22-6.95,12.25-5.85S325,260.61,324.29,264.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.18,266.33l-1,1.08-1.12-1.09.94-1a7.09,7.09,0,0,1-1.7-3l1.89-.82a5.83,5.83,0,0,0,1.55,2.76c.77.75,1.27.81,1.56.49,1-1.08-3.45-3.91-1.17-6.43,1-1.06,2.52-1.25,4.2,0l1-1.06,1.12,1.09-.95,1a6.45,6.45,0,0,1,1.38,2.42l-1.86.87a5.49,5.49,0,0,0-1.33-2.29c-.78-.75-1.31-.75-1.61-.42-.94,1,3.47,3.87,1.21,6.37C314.36,267.33,312.84,267.53,311.18,266.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.66,252.09s4.77,2.42.19,6l-7-2.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.47,244.89s4.6,4.86,9-.2l-5.42-1.81Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.54,290.77s6.19-5,9.8,1.76l-6.91,4.62Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.38,276.2s-4.47,2.8-1.44,8.57l4.58-3.06Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81,292.42a1.88,1.88,0,1,1-1.87-1.94A1.9,1.9,0,0,1,323.81,292.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.57,280.49a1.87,1.87,0,1,1-1.87-1.94A1.9,1.9,0,0,1,342.57,280.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.93,244.7c0,.69-1,1.25-2.15,1.25s-2.14-.56-2.14-1.25,1-1.25,2.15-1.25S303.93,244,303.93,244.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,255.07a2.13,2.13,0,1,1-2.08-1.66A1.91,1.91,0,0,1,285.65,255.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.89,254c0,1.06-1.32,1.92-2.95,1.92S297,255.09,297,254s1.32-1.92,2.95-1.92S302.89,253,302.89,254Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.58,279.72c-1.33.61-3-.23-3.66-1.87a3.07,3.07,0,0,1,1.15-4.07c1.33-.61,3,.23,3.66,1.88A3.06,3.06,0,0,1,326.58,279.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.08,245.81,296.63,258s4.62,5.29,7.73,2.79-1.26-7.16-2.18-8.52-12.24-15.09-12.24-15.09Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,234.85a7.35,7.35,0,0,1-.45,2.11,22.1,22.1,0,0,1-2,4.79,16.23,16.23,0,0,1-3.29,4.06,6,6,0,0,1-1.78,1.22,17.86,17.86,0,0,1,1.53-1.49,20.1,20.1,0,0,0,3.09-4C290.09,238,290.86,234.79,291,234.85Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.58,282.43a3.79,3.79,0,0,1-.54.53l-1.61,1.44-6,5.21c-5.09,4.37-12.16,10.38-20,16.93S140.3,319,135,323.08c-2.64,2.08-4.81,3.71-6.33,4.83l-1.76,1.25a3.71,3.71,0,0,1-.63.41,5.36,5.36,0,0,1,.57-.49l1.7-1.34c1.48-1.16,3.61-2.83,6.22-4.94,5.23-4.21,12.39-10.11,20.27-16.66s14.94-12.48,20.14-16.81l6.11-5.09,1.68-1.36A4.21,4.21,0,0,1,183.58,282.43Z",
    style: {
      fill: "#eb996e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage3);
export default __webpack_public_path__ + "static/media/image_3.d306d69f47d881c676e102a92fac2c59.svg";
export { ForwardRef as ReactComponent };